import { loomUrlRegex, vimeoUrlRegex, youtubeUrlRegex } from "./regex"

export function getYouTubeIdFromUrl(url: string): string | null {
	const match = url.match(youtubeUrlRegex)
	return match?.[1] ?? null
}

export function getYouTubeUrlFromId(id: string | null): string {
	return id ? `https://www.youtube.com/watch?v=${id}` : ""
}

export function getVimeoIdFromUrl(url: string): string | null {
	const match = url.match(vimeoUrlRegex)
	return match?.[1] ?? null
}

export function getVimeoUrlFromId(id: string | null): string {
	return id ? `https://vimeo.com/${id}` : ""
}

export function getLoomIdFromUrl(url: string): string | null {
	const match = url.match(loomUrlRegex)
	return match?.[1] ?? null
}

export function getLoomUrlFromId(id: string | null): string {
	return id ? `https://www.loom.com/share/${id}` : ""
}
